import axios from 'axios';

export const AxiosS3UploadInstance = axios.create();
